import _styled, { default as _styled2, default as _styled3, default as _styled4, default as _styled5 } from "styled-components";
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
/* istanbul ignore file */
import React, { useCallback, useState } from 'react';
import { sendGAEvent } from '@noths/polaris-client-google-analytics';
import { withScopedBaseStyles } from '@noths/polaris-client-ribbons-base';
import * as styles from "./Header.styles";
import { searchBarContainerHidden } from "./Header.styles";
import { ContentOverlay } from "../../atoms/ContentOverlay/ContentOverlay";
import { SiteLogo } from "../../atoms/SiteLogo/SiteLogo";
import { IconBar } from "../../molecules/IconBar/IconBar";
import { LocaleModal } from "../../molecules/LocaleModal/components/LocaleModal";
import { SearchBarContainer } from "../../molecules/SearchBarContainer/SearchBarContainer";
import { SearchSuggestionsContainer } from "../../molecules/SearchSuggestions/SearchSuggestionsContainer";
import { SearchContextProvider } from "../../../context/SearchContext/SearchContextProvider";
import { useSiteChromeDynamicContext } from "../../../context/SiteChromeDynamicContext/useSiteChromeDynamicContext";
import { useSiteChromeStaticContext } from "../../../context/SiteChromeStaticContext/useSiteChromeStaticContext";
import { UserContextProvider } from "../../../context/UserContext/UserContextProvider";
var HeaderComponent = function HeaderComponent() {
  var _useSiteChromeDynamic = useSiteChromeDynamicContext(),
    _useSiteChromeDynamic2 = _slicedToArray(_useSiteChromeDynamic.locale, 2),
    currentLocale = _useSiteChromeDynamic2[0],
    setLocale = _useSiteChromeDynamic2[1],
    _useSiteChromeDynamic3 = _useSiteChromeDynamic.localeModal,
    close = _useSiteChromeDynamic3.close,
    closeAfterSave = _useSiteChromeDynamic3.closeAfterSave,
    isOpen = _useSiteChromeDynamic3.isOpen,
    placement = _useSiteChromeDynamic3.placement;
  var _useSiteChromeStaticC = useSiteChromeStaticContext(),
    _useSiteChromeStaticC2 = _useSiteChromeStaticC.compact,
    compact = _useSiteChromeStaticC2 === void 0 ? false : _useSiteChromeStaticC2,
    env = _useSiteChromeStaticC.env,
    useScopedStyles = _useSiteChromeStaticC.useScopedStyles;
  var _useState = useState(!compact),
    _useState2 = _slicedToArray(_useState, 2),
    searchBarVisible = _useState2[0],
    setSearchBarVisible = _useState2[1];
  var onSave = useCallback(function (updatedLocale) {
    setLocale(updatedLocale, placement);
    closeAfterSave();
  }, [closeAfterSave, placement, setLocale]);
  var onClose = useCallback(function () {
    return close();
  }, [close]);
  var toggleSearchBar = function toggleSearchBar() {
    sendGAEvent({
      event: 'custom_event',
      event_category: 'Header',
      event_action: searchBarVisible ? 'collapse' : 'expand',
      event_label: 'Search'
    });
    setSearchBarVisible(function (searchBarVisible) {
      return !searchBarVisible;
    });
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_StyledHeader, {
    "data-nosnippet": true,
    $_css: styles.header
  }, /*#__PURE__*/React.createElement(_StyledDiv, {
    $_css2: styles.headerInner(searchBarVisible)
  }, /*#__PURE__*/React.createElement(_StyledDiv2, {
    $_css3: styles.siteLogo
  }, /*#__PURE__*/React.createElement("a", {
    href: "/"
  }, /*#__PURE__*/React.createElement(SiteLogo, {
    env: env
  }))), /*#__PURE__*/React.createElement(SearchContextProvider, null, /*#__PURE__*/React.createElement(_StyledDiv3, {
    $_css4: [styles.searchBarContainer, !searchBarVisible && searchBarContainerHidden]
  }, /*#__PURE__*/React.createElement(SearchBarContainer, null), /*#__PURE__*/React.createElement(SearchSuggestionsContainer, null))), /*#__PURE__*/React.createElement(_StyledDiv4, {
    $_css5: styles.iconBar
  }, /*#__PURE__*/React.createElement(UserContextProvider, null, /*#__PURE__*/React.createElement(IconBar, {
    compact: compact,
    onSearchIconClick: toggleSearchBar,
    searchIconActive: searchBarVisible
  })))), /*#__PURE__*/React.createElement(LocaleModal, {
    isOpen: isOpen,
    locale: currentLocale,
    onClose: onClose,
    onSave: onSave,
    useScopedStyles: useScopedStyles
  })), /*#__PURE__*/React.createElement(ContentOverlay, null));
};
export var Header = withScopedBaseStyles(HeaderComponent);
var _StyledHeader = _styled("header")(_templateObject || (_templateObject = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css;
});
var _StyledDiv = _styled2("div")(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css2;
});
var _StyledDiv2 = _styled3("div")(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css3;
});
var _StyledDiv3 = _styled4("div")(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css4;
});
var _StyledDiv4 = /*#__PURE__*/_styled5("div").withConfig({
  displayName: "Header___StyledDiv4",
  componentId: "sc-7t6agg-0"
})(["", ""], function (p) {
  return p.$_css5;
});